import React from 'react';
import PropTypes from 'prop-types';
import { generateGridStyles } from '../components/helpers';
import { generateUniqueId } from '../../../common/utils/utils';

const Text = ({ getHandlers, val, gridStyles, name }) => {
    const { stylers, classes } = generateGridStyles(gridStyles, name);
    return (
        <p {...getHandlers(false)} className={classes.wrapper} style={stylers.wrapper} key={generateUniqueId()}>
            <p> {val?.text || ''} </p>
        </p>
    );
};
Text.propTypes = {
    getHandlers: PropTypes.func,
    name: PropTypes.string,
    link: PropTypes.string,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string])
};
export default Text;
